import { useContext } from 'react';
import { useSelector } from 'react-redux';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'marketplace-ui-common/callouts/constants/FeaturedCallouts';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import { useFeaturedCallouts } from 'marketplace-ui-common/callouts/hooks/useFeaturedCallouts';
import CoreFeaturedCallout from 'marketplace-ui-common/callouts/components/FeaturedCallout';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';

//@ts-expect-error untyped dependency
import { getIsPublic } from '../../selectors/auth';
import { useAppContext } from '../../context/AppContext.tsx';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
//@ts-expect-error untyped dependency
import { getPublicAppMKPLUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
function FeaturedCallout({
  callout,
  layout
}) {
  var _collection$published;
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const appContext = useAppContext();
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const {
    data: collections
  } = useCollections({
    appContext,
    offeringType: 'APP'
  });
  const collection = collections.find(c => c.id === collectionId);
  const collectionSlug = collection === null || collection === void 0 || (_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.slug;

  /**
   * Following logic will check for Public MKPL `externalUrl` in callout CTA and if so:
   * Will keep redirect if we are in In-App MKPL to guarantee smooth routing behaviour
   */
  const publicAppMKPLUrl = getPublicAppMKPLUrl();
  const isPublicAppMKPLUrl = externalUrl === null || externalUrl === void 0 ? void 0 : externalUrl.startsWith(publicAppMKPLUrl);
  const isExternalLinkProp = !!externalUrl && !isPublicAppMKPLUrl;
  const LinkComponent = isExternalLinkProp ? UILink : UIRouterLink;
  const link = collectionSlug ? `/${collectionSlug}` : isPublicAppMKPLUrl ? externalUrl === null || externalUrl === void 0 ? void 0 : externalUrl.replace(publicAppMKPLUrl, '') : externalUrl;
  const linkProps = isExternalLinkProp ? {
    href: link
  } : {
    to: link
  };
  const i18nKey = typeof id === 'string' ? id : `featuredCallout_${id}`;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.buttonText,
      WrapperComponent: "span"
    }),
    description: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.description,
      WrapperComponent: "span"
    }),
    gradientColor: publishedListing.gradientColor,
    headline: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.headline,
      WrapperComponent: "span"
    }),
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: linkProps,
    onClick: () => {
      trackInteraction('click featured callout', {
        section: `featured-callout::${i18nKey}::static`
      });
    },
    external: isExternalLinkProp,
    responsive: true
  });
}
export default function FeaturedCalloutsSection() {
  const isPublicApp = useSelector(getIsPublic);
  const isMobile = useIsMaxScreenSize('sm');
  const {
    data: callouts
  } = useFeaturedCallouts({
    appContext: isPublicApp ? 'public' : 'app',
    offeringType: 'APP'
  });
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: "p-bottom-10",
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout
    }, callout.id))
  });
}